// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { AlertState } from "@/types/alert";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Alert } from "@/models/alert";

const state: AlertState = {
  single: new Alert(),
  pagination: new Pagination(),
};

export const alert: Module<AlertState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
